/**
 * Extract a human-readable message from a failed member-API response body or a
 * thrown error, so UI never surfaces "undefined" (PLO-4803). The members API
 * follows the house convention of HTTP 200 with `{ success: false, error }` on
 * business errors, but also returns non-2xx / crash bodies; this normalises all
 * of them to a single readable string.
 */
export const memberErrorMessage = (
  source: unknown,
  fallback = "Something went wrong. Please try again.",
): string => {
  if (typeof source === "string" && source.trim()) return source.trim();

  if (source instanceof Error && source.message.trim()) {
    return source.message.trim();
  }

  if (source && typeof source === "object") {
    const body = source as {
      error?: unknown;
      message?: unknown;
      description?: unknown;
    };
    if (typeof body.error === "string" && body.error.trim()) {
      return body.error.trim();
    }
    if (typeof body.message === "string" && body.message.trim()) {
      return body.message.trim();
    }
    if (
      Array.isArray(body.description) &&
      typeof body.description[0] === "string" &&
      body.description[0].trim()
    ) {
      return body.description[0].trim();
    }
  }

  return fallback;
};
